export default __webpack_public_path__ + "static/media/linux.54ab9e9d.png";